<div class="chatbot-container">

  <!-- SIDEBAR: lista de conversaciones -->
  <aside class="chatbot-sidebar">
    <div class="sidebar-header">
      <h3>Soporte</h3>
      <button class="btn-new" (click)="newConversation()" title="Nueva conversación">
        <i class="ri-add-line"></i>
      </button>
    </div>

    <div class="conversation-list">
      <div
        *ngFor="let conv of conversations"
        class="conversation-item"
        [class.active]="conv.id === currentConversationId"
        (click)="openConversation(conv)">
        <div class="conv-title">
          <i class="ri-chat-3-line"></i>
          <span>{{ conv.title }}</span>
        </div>
        <span *ngIf="conv.escalated" class="badge-escalated" title="Escalada a soporte humano">
          <i class="ri-user-3-line"></i>
        </span>
      </div>
      <div *ngIf="conversations.length === 0" class="empty-state">
        Aún no tienes conversaciones. Empieza escribiendo abajo.
      </div>
    </div>
  </aside>

  <!-- ZONA PRINCIPAL: chat -->
  <section class="chatbot-main">

    <header class="chat-header">
      <div>
        <h2>Asistente de soporte</h2>
        <small>Resolvemos tus dudas sobre Nectum</small>
      </div>
      <button
        class="btn-escalate"
        *ngIf="currentConversationId && !escalated"
        (click)="escalate()"
        title="Escalar a soporte humano">
        <i class="ri-customer-service-2-line"></i>
        Escalar a soporte humano
      </button>
      <span *ngIf="escalated" class="escalated-label">
        <i class="ri-check-line"></i> Conversación escalada
      </span>
    </header>

    <div class="chat-messages" #scrollContainer>
      <div
        *ngFor="let msg of messages"
        class="message"
        [class.user]="msg.role === 'USER'"
        [class.assistant]="msg.role === 'ASSISTANT'">
        <div class="message-bubble">
          <div class="message-content">{{ msg.content }}</div>
          <div class="message-time">{{ msg.createdAt | date:'HH:mm' }}</div>
        </div>
      </div>

      <div *ngIf="loading" class="message assistant">
        <div class="message-bubble typing">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>

    <div class="chat-input">
      <textarea
        [(ngModel)]="inputText"
        (keydown)="onKeydown($event)"
        placeholder="Escribe tu mensaje..."
        rows="1"
        [disabled]="loading"></textarea>
      <button
        class="btn-send"
        (click)="send()"
        [disabled]="loading || !inputText.trim()"
        title="Enviar">
        <i class="ri-send-plane-2-line"></i>
      </button>
    </div>

  </section>

</div>

